// onAccountBalancesPageMatch.js - Orchestrator for account balances/sheet page enhancements.

if (typeof window.auditMode === 'undefined') {
  window.auditMode = false
}

const onAccountBalancesPageMatch = () => {
  console.log('Lux Inject: Running onAccountBalancesPageMatch')

  // --- Extract IDs and Dates ---
  const path = window.location.pathname // e.g., /account-sheet/property/WEG00027/account/800%2F0
  const searchParams = new URLSearchParams(window.location.search) // e.g., ?startDate=...&endDate=...

  // Captures propertyHrId (group 1) and account_id (group 2)
  //https://app.local.erste-hausverwaltung.de/dashboard/account-sheet/property/WEG00032/account/800?startDate=2024-01-01&endDate=2024-12-31
  const urlRegex =
    /^\/dashboard\/account-sheet\/property\/([^/]+)\/account\/([^/]+)/
  let match = path.match(urlRegex)
  let user = 'advisory council'

  if (!match) {
    const urlRegex = /^\/account-balances\/([^/]+)\/account\/([^/]+)/
    match = path.match(urlRegex)
    user = 'administrator'
  }

  if (match) {
    const propertyHrId = match[1]
    const account_id = decodeURIComponent(match[2]) // Decode potentially URL-encoded account ID
    const startDate = searchParams.get('startDate')
    const endDate = searchParams.get('endDate')

    console.log('Extracted propertyHrId:', propertyHrId)
    console.log('Extracted account_id:', account_id)
    console.log('Extracted startDate:', startDate)
    console.log('Extracted endDate:', endDate)

    // --- Save Date Range to localStorage ---
    if (startDate && endDate) {
      try {
        const dateRange = JSON.stringify({ startDate, endDate })
        localStorage.setItem('lux_balanceDateRange', dateRange)
        console.log('Saved date range to localStorage:', dateRange)
      } catch (e) {
        console.error('Error saving date range to localStorage:', e)
      }
    } else {
      // Clear localStorage if dates are missing to avoid using stale data
      localStorage.removeItem('lux_balanceDateRange')
      console.log(
        'Cleared date range from localStorage as startDate or endDate is missing.'
      )
    }

    // --- Initial Backend Call (Optional Processing) ---
    if (propertyHrId && account_id && startDate && endDate) {
      console.log('Calling backend to process account balances (if needed)...')
      Lux_ApiClient_post('/api/process-account-balances', {
        propertyHrId: propertyHrId,
        account_id: account_id,
        startDate: startDate,
        endDate: endDate,
      })
        .then(async (response) => {
          const responseData = await response.json().catch(() => ({})) // Gracefully handle non-JSON response
          if (!response.ok) {
            console.error(
              'Backend processing error:',
              response.status,
              responseData.error || 'Unknown error'
            )
          } else {
            console.log('Backend processing successful:', responseData)
          }
        })
        .catch((error) => {
          // Catch errors from Lux_ApiClient_post (like token missing) or network errors
          console.error('Error calling backend processing endpoint:', error)
        })
    } else {
      console.warn(
        'Missing required parameters (propertyHrId, account_id, startDate, or endDate) in URL. Skipping initial processing call.'
      )
    }

    // --- Initialize Bulk Revert Button ---
    if (typeof Lux_initializeBulkRevertButton === 'function') {
      Lux_initializeBulkRevertButton()
    } else {
      console.error('Lux_initializeBulkRevertButton function not found!')
    }

    // --- Initialize Table Enhancements ---
    // This will now use MutationObserver to wait for the table and then enhance it.
    if (
      typeof Lux_Table_initializeAccountBalancesTableEnhancements === 'function'
    ) {
      if ((user === 'advisory council') || window.auditMode) {
        Lux_Table_initializeAccountBalancesTableEnhancements(user)
      } else {
        Lux_Table_initializeAuditModeButton()
      }
    } else {
      console.error(
        'Lux_Table_initializeAccountBalancesTableEnhancements function not found! Table enhancements will not be applied.'
      )
    }
  } else {
    console.log(
      'Could not extract propertyHrId and account_id from path:',
      path,
      'Skipping account balances page enhancements.'
    )
  }
}
